export const BATTLE_TRAITS_TWAR = [
    {
        name: 'Personaggio',
        keywords_a: ['character'],
        keywords_r: ['monster', 'vehicle'],
        dices: {
            "1": {
                name: 'BORN HUNTER',
                flavor: 'Perhaps a survivor of a fallen Sa/blade farce or the hyper-evolved remnant of a butchered brood, this warrior is terrifyingly swift and eager to engage the foe once more.',
                description: 'This unit has the Scouts 9" ability (Core Rules).'
            },
            "2": {
                name: 'BIO-ACID BURNS',
                flavor: 'Even Tyranid ichor is a deadly threat; a survivor bearing the livid scars of irs excoriating rauch is an indomitable and enduring combatant indeed.',
                description: 'CHARACTER models in this unit have the Feel No Pain S+ ability (Core Rules).'
            },
            "3": {
                name: 'NATURAL LEADER',
                flavor: 'This warrior carries an aurhoriry and presence thar inspires or dominates rhose around them. ',
                description: 'Each time you take a Battle-shock or Leadership test for this unit, you can re-roll that test.'
            },
            "4": {
                name: 'DEADLY COMBATANT',
                flavor: 'This violent champion has adopted the mantra thar rhe only way ro beat the xenos swarms is ro fight ralon and Jang wirh blade and dererminarion. All me lee weapons equipped by CHARACTER models',
                description: 'in this unit have the [SUSTAINED HITS 1] ability(Core Rules). '
            },
            "5": {
                name: 'SHADOW STALKER',
                flavor: 'This warrior has learned ro move unseen, haunting irs prey from dark ruins or through nests of xenos growths ro evade detection.',
                description: 'This unit has the Stealth ability (Core Rules).'
            },
            "6": {
                name: 'DEATH INCARNATE [AURA]',
                flavor: 'A palpable sense of dread swathes this red-handed killer like a shroud, rheir eyes carrying neither mercy nor piry, only rhe promise of dearh. ',
                description: " While an enemy unit is within 6'' of this unit, worsen the Leadership characteristic of models in that enemy unit by 1."
            },

        }
    },
    {
        name: 'Veicolo',
        keywords_a: ['vehicle'],
        keywords_r: ['walker'],
        dices: {
            "1": {
                name: 'BLESSED HULL',
                flavor: 'The crew of rhis vehicle hold rhe unshakeable belief that the words of warding and sacred unguents with which it has been blessed offer them supernatural protection. In such a warp-sarurared age, belief has a power all its own.',
                description: 'Models in this unit have a 5+ invulnerable save.',
            },
            "2": {
                name: 'FOCUSED GUNNERS',
                flavor: 'Though hordes of monstrosities may swarm around rhem, rhis vehicle\'s gunners maintain a grim calm and blast away ar any crawling over rhe hull. ',
                description: 'Models in this unit do not suffer the penalty to Hit rolls for making ranged attacks while their unit is within Engagement Range of one or more enemy units.',
            },
            "3": {
                name: 'REINFORCED SUPERSTRUCTURE',
                flavor: 'This vehicle\'s commander hos ordered the srrengrhening of key elements of irs armoured hide after learning valuable lessons in barrle against rhe Tyranids.',
                description: 'Each time an attack with a Strength characteristic of 7 or less is allocated to a model in this unit, worsen the Armour Penetration characteristic of that attack by 1.',
            },
            "4": {
                name: 'ELITE CREW',
                flavor: 'The crew of this vehicle ore hardened veterans, rheir slick coordination forged through shared bartlejield experience.',
                description: 'Each time a model in this unit makes an attack, re-roll a Hit roll of 1.',
            },
            "5": {
                name: 'ARCHEOTECH POWER CELL',
                flavor: 'An arcane mechanism now boosrs rhis vehicle\'s performance, as speed and mobility quickly became viral survival srraregies against rhe Tyranids.',
                description: "Add 2--to the Move characteristic of models in this unit.",
            },
            "6": {
                name: 'AUTO-REPAIR NODES',
                flavor: 'This vehicle is fitted with advanced devices that counreracr bio-acids, seal renrs ram by talons, purge metallaphagic growths and effect numerous other repairs.',
                description: 'At the start of your Command phase, one model in this unit regains 1 lost wound.',
            },
        }
    },
    {
        name: 'Fanteria',
        keywords_a: ['infantry'],
        keywords_r: [],
        dices: {
            "1": {
                name: "BATTLE-SCARRED RESISTANCE",
                flavor: "With their tough skin mo Wed by scors ond shielded by thickened carapace or reinforced armour, these    warriors hove survived hurricanes of firepower, toking    numerous injuries but never giving in.",
                description: "Models in this unit have the Feel No Pain 6+ ability (Core Rules).",
            },
            "2": {
                name: "VANGUARD ESPIONAGE",
                flavor: "Granted greater autonomy to operate far ahead    of the main battle lines, these veterans push    forward through hellish conditions to probe the    foe's defences.",
                description: "This unit has the Scouts 9'' ability [Core Rules].",
            },
            "3": {
                name: "OBDURATE OBEDIENCE",
                flavor: "Warriors who put duty before their own lives or    organisms exhibiting particularly rigid links to the    Hive Mind are such reliable troops that they will    secure their objectives regardless of any danger. Such troops are as much despised by the enemy as    they are valued by their commanders.",
                description: "Add 1 to the Objective Control characteristic of all    models in this unit.",
            },
            "4": {
                name: "RESOLUTE VETERANS",
                flavor: "The alien horror on countless worlds in the    Segmentum Pacijicus has driven many insane,    but some refuse to yield, no longer fazed by    the devastation.",
                description: "Each time you take a Battle-shock, Leadership or    Desperate Escape test for this unit, add 1 to that test.",
            },
            "5": {
                name: "ONLY THE SWIFT SURVIVE",
                flavor: "On worlds preyed upon by the Tyronids, survival    means moving fast and killing first. These warriors    outpace their foes and instinctively drive their    sloshing blades or stabbing talons into the foe before    they con even react.",
                description: "Add 1 to Advance and Charge rolls made for this unit.",
            },
            "6": {
                name: "HEADHUNTERS",
                flavor: "Whether by the inscrutable Hive Mind or the authority    of high command, as opposing armies close on each    other these dedicated executioners are assigned a    priority target to kill at all costs.",
                description: "At the start of the battle, select one enemy unit  (regardless of how many units in your Crusade army    have this Battle Trait). Until the end of the battle, each    time a model in this unit makes an attack against that    enemy unit, re-roll a Hit roll of 1 and re-roll a Wound    roll of 1.",
            },
        },
    },
    {
        name: 'A cavallo',
        keywords_a: ['mounted'],
        keywords_r: [],
        dices: {
            "1": {
                name: "HUNTER'S CELERITY",
                flavor: "When hunting down elusive prey or evading the taloned clutches of xenos horrors, these swift warriors unlock a reserve of unmatched speed. ",
                description: "Add 2'' to the Move characteristic of models in this unit.",
            },
            "2": {
                name: "HIGH-SPEED GUNNERY",
                flavor: "These swift dragoons hove perfected the firing and reloading of their deadly weapons at high speed, always moving to ovoid the hunting broods.",
                description: "Each time this unit Advances, until the end of the turn all ranged weapons equipped by models in this unit have the [ASSAULT] ability (Core Rules).",
            },
            "3": {
                name: "PREDATORY URGE",
                flavor: "aIi These butchers revel in tearing their prey apart in a;II gory chunks and eagerly surge forward at every ~ opportunity to do so.",
                description: "You can re-roll Charge rolls made for this unit.",
            },
            "4": {
                name: "MOUNTED GUERRILLAS",
                flavor: "A key tactic of many So/blade forces was to strike hard and fast against the Tyronids, enable o rapid extraction, redeploy and engage again at the first chance.",
                description: "This unit is eligible to declare a charge in a turn in which it Fell Back.",
            },
            "5": {
                name: "ENCIRCLING RAPTORS",
                flavor: "These swift flanking troops ore able to outmanoeuvre the surging xenos broods, encircling the swarms before striking from an unexpected quarter.",
                description: "If this unit is in Strategic Reserves, it counts the battle round number as one higher than the current battle round number for the purpose of determining when and where it is set up.",
            },
            "6": {
                name: "TIRELESS RAIDERS",
                flavor: "Aiming from vantage points high on the bocks of rearing mounts or firing weapons shielded in armoured housings, these warriors eviscerate their foes at point-blank range as they weave through swarming horrors.",
                description: "Models in this unit can make attacks with ranged weapons even when their unit is within Engagement Range of enemy units, but they can only make such attacks against enemy units that they are within Engagement Range of. In such circumstances, those models can target an enemy unit even if other friendly units are within Engagement Range of the same enemy unit.",
            },
        },
    },

]

















